export const redirect = {
  redirectText: 'Redireccionando, por favor espere...',
}



// WEBPACK FOOTER //
// ./src/sections/redirection/text.js